import loadable from '@loadable/component'

const FlexForm = loadable(() => import('components/flex/Form/FormShell'))
const FlexText = loadable(() => import('components/flex/Components/Text'))
const FlexMoreInformation = loadable(
  () => import('components/flex/Components/MoreInformation')
)
const FlexGreyBlocks = loadable(
  () => import('components/flex/Components/GreyBlocks')
)
const FlexFaq = loadable(() => import('components/flex/Components/FAQ'))
const FlexSliderLogos = loadable(
  () => import('components/flex/Components/Slider')
)
const FlexContact = loadable(() => import('components/flex/Components/Contact'))
const FlexAllVacancies = loadable(
  () => import('components/flex/Components/AllVacancies')
)
const FlexFragment = loadable(() => import('components/flex/Fragment'))
const FlexCaseLayout = loadable(
  () => import('components/flex/Components/CaseLayout')
)
const FlexAllArticles = loadable(
  () => import('components/flex/Components/AllArticles')
)
const FlexHomeText = loadable(() => import('components/flex/Text/TextShell'))
const FlexHomeBanner = loadable(() => import('components/flex/Banner/BannerShell'))
const FlexHomeVacancies = loadable(
  () => import('components/flex/Vacancies/VacanciesShell')
)

const sharedFlexers = {
  Flex_Form: FlexForm,
  Flex_Text: FlexText,
  Flex_MoreInformation: FlexMoreInformation,
  Flex_GreyBlocks: FlexGreyBlocks,
  Flex_Faq: FlexFaq,
  Flex_SliderLogos: FlexSliderLogos,
  Flex_Contact: FlexContact,
  Flex_AllVacancies: FlexAllVacancies,
  Flex_Fragment: FlexFragment,
  Flex_CaseLayout: FlexCaseLayout,
  Flex_AllArticles: FlexAllArticles,
}

const pageOnlyFlexers = {
  FlexHome_Text: FlexHomeText,
  FlexHome_Banner: FlexHomeBanner,
  FlexHome_Vacancies: FlexHomeVacancies,
}

const withPrefix = (
  prefix: string,
  flexers: Record<string, ReturnType<typeof loadable>>
) =>
  Object.fromEntries(
    Object.entries(flexers).map(([key, component]) => [
      `${prefix}_${key}`,
      component,
    ])
  )

const registryCache: Record<string, ReturnType<typeof withPrefix>> = {}

export const getFlexersForPrefix = (
  prefix: string,
  includeHomeBlocks = false
) => {
  const cacheKey = `${prefix}:${includeHomeBlocks}`

  if (registryCache[cacheKey]) {
    return registryCache[cacheKey]
  }

  const flexers = includeHomeBlocks
    ? { ...sharedFlexers, ...pageOnlyFlexers }
    : sharedFlexers

  registryCache[cacheKey] = withPrefix(prefix, flexers)
  return registryCache[cacheKey]
}
